import { VisitIdBrowserAdapter } from "./browser/plugins/visitId/adapter.es.js";
const getCookieHandler = (adapter) => {
  if (typeof window !== "undefined") {
    return new VisitIdBrowserAdapter();
  }
  if (adapter) {
    return adapter;
  }
  throw new Error(
    "When calling getVisitId() on the server, you must pass one of the provided server adapters. If this call was meant to come from the Browser only, please ensure SSR doesn’t call it as well. See the Event Horizon docs for more info."
  );
};
export {
  getCookieHandler as g
};
